import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get an expedited passport in Greenville, SC?",
    a: "Through Fast Passport Center, expedited passport processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a Greenville area post office or acceptance clerk typically takes 6–13 weeks.",
  },
  {
    q: "Where is the closest passport agency to Greenville for emergency passports?",
    a: "The nearest regional passport agency is the Atlanta Passport Agency at 230 Peachtree Street NW, Suite 1000, Atlanta, GA 30303 — approximately 2.5 hours from Greenville. Regional agencies require appointments and are primarily reserved for life-or-death emergencies. Fast Passport Center can often provide a faster, more convenient option.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center for my expedited passport?",
    a: "No — most Greenville travelers start online and ship their documents via overnight courier. Start your emergency passport order online, follow the checklist, and ship your documents overnight from anywhere in the Greenville and Upstate area.",
  },
  {
    q: "Is GSP International Airport good for direct international flights?",
    a: "Greenville-Spartanburg International (GSP) offers direct service to major hubs including Charlotte, Atlanta, and New York. For direct transatlantic or transpacific flights, many Greenville-area residents drive to Charlotte Douglas (CLT) about 1.5 hours away or Hartsfield-Jackson Atlanta (ATL) about 2.5 hours away.",
  },
  {
    q: "What documents do I need for an expedited passport in Greenville?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your expedited passport order.",
  },
  {
    q: "How long does a passport take through the post office in Greenville?",
    a: "Standard government processing through a Greenville area acceptance facility can take 6–13 weeks depending on government workload. If your travel date is sooner, using an approved passport courier like Fast Passport Center is the safer option.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
  {
    q: "What if I need a child passport in Greenville?",
    a: "Child passports (for minors 15 and under) require parental participation and an in-person acceptance step — both parents typically must consent. We provide clear instructions and a checklist so you know exactly what to do at a Greenville area acceptance facility.",
  },
];

export default function GreenvilleSCFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span> About Expedited Passports in Greenville
          </h2>
          <p className="text-gray-500 text-base">
            Everything Greenville and Upstate South Carolina travelers ask us most often about emergency and expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a href="tel:8772530084" className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap">
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}